import { getCoreUtils, nz } from "../../../Admin/kReusableCoreTS/kCoreHandler";

// AppChatStanding - ONE WORD PER STANDING, EVERYWHERE (audit 2026-10-02).
//
// A conversation's standing is a code in `index.json` ("owed", "active", "quiet", "concluded") and a set of flags in the
// service's analysis. It was put into words in two places that did not agree: the chat list said "Finished" and "Quiet"
// where the contact page said "Concluded" and "Dormant". Two names for one state, on two screens of one product, read
// as two different states. The words live here now; the list (`AppViews.StandingWords`), the chat header
// (`AppChatHead.Fields`) and the contact page (`DossierHtml.StandingPill`, Bridge) all read them.
//
// Habitat-free (no DOM, no transport): the Bridge imports it, like `AppTaskTips`.

export class AppChatStanding {
    /**
     * The standing in plain words (design system, 2026-09-30: "plain wordings"): the index's word is a code, not a
     * sentence - "owed" means the ball is in the owner's court. An unknown code is shown as written, capitalised.
     */
    public static Words = (Standing: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            const Word: string = nz(Standing).trim().toLowerCase();
            if (Word === "owed") { return "Waiting on you"; }
            if (Word === "active") { return "Active"; }
            if (Word === "quiet") { return "Quiet"; }
            if (Word === "concluded") { return "Finished"; }
            if (Word.length === 0) { return ""; }
            return Word.substring(0, 1).toUpperCase() + Word.substring(1);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppChatStanding.Words");
            return "";
        }
    };
}
